// extracted by mini-css-extract-plugin
module.exports = {"ionModal":"style_ionModal__2rqDQ","ionSearchbar":"style_ionSearchbar__I7Jeb","ionContent":"style_ionContent__76xOT"};